<template>
    <div class="vuetable-filterbar col-md-12">
	    <div class="form-group p-l">
            <b-container fluid class="p-a-0">
                <b-row no-gutters>
                    <b-col sm="6" md="1" class="p-a-0 m-t-5px">
                        <div class="fl-flex-label fl-collapsed fl-background">
                            <input type="text" class="form-control" v-model="cd" @keyup.enter="doFilter">
                            <label class="fl-label" for="default-input" style="left: 13px; right: 12px;">Código</label>
                        </div>
                    </b-col>
                    <b-col sm="6" md="1" class="p-a-0 m-t-5px">
                        <div class="fl-flex-label fl-collapsed fl-background">
                            <input type="text" class="form-control" v-model="cd_erp" @keyup.enter="doFilter">
                            <label class="fl-label" for="default-input" style="left: 13px; right: 12px;">Código ERP</label>
                        </div>
                    </b-col>
                    <b-col sm="6" md="2" class="p-a-0 m-t-5px">
                        <div class="fl-flex-label fl-collapsed fl-background">
                            <input type="text" class="form-control" v-model="descr" @keyup.enter="doFilter">
                            <label class="fl-label" for="default-input" style="left: 13px; right: 12px;">Descrição</label>
                        </div>
                    </b-col>
                    <b-col sm="6" md="2" class="p-a-0 m-t-5px">
                        <multiselect v-model="mandatorio"
                        :options="optionsLivMandatorio"
                        track-by="value"
                        label="label"
                        :hide-selected="true"
                        placeholder="Mandatório"
                        tag-placeholder="Selecionar"
                        select-label="Selecionar"
                        selected-label="Selecionado"
                        deselect-label="Remover"
                        ></multiselect>
                    </b-col>
                    <b-col sm="6" md="2" class="p-a-0 m-t-5px">
                        <multiselect v-model="custo"
                        :options="optionsParamCusto"
                        track-by="value"
                        label="label"
                        :hide-selected="true"
                        placeholder="Tipo Custo"
                        tag-placeholder="Selecionar"
                        select-label="Selecionar"
                        selected-label="Selecionado"
                        deselect-label="Remover"
                        ></multiselect>
                    </b-col>
                    <b-col sm="6" md="2" class="p-a-0 m-t-5px">
                        <multiselect v-model="rateio"
                        :options="optionsParamRateio"
                        track-by="value"
                        label="label"
                        :hide-selected="true"
                        placeholder="Tipo Rateio"
                        tag-placeholder="Selecionar"
                        select-label="Selecionar"
                        selected-label="Selecionado"
                        deselect-label="Remover"
                        ></multiselect>
                    </b-col>
                    <b-col sm="6" md="2" class="p-a-0 m-t-5px">
                        <multiselect v-model="status"
                        :options="optionsLivStatus"
                        track-by="value"
                        label="label"
                        :hide-selected="true"
                        placeholder="Status"
                        tag-placeholder="Selecionar"
                        select-label="Selecionar"
                        selected-label="Selecionado"
                        deselect-label="Remover"
                        ></multiselect>
                    </b-col>
                    <b-col sm="6" md="2" class="m-t-5px">
                        <div class="input-group-btn">
                            <div class="btn-group">
                                <button type="button" class="btn btn-secondary btn-outline" @click="doFilter" :disabled="vuetableFilterButton">Filtrar</button>
                                <button type="button" class="btn btn-secondary btn-outline" @click="resetFilter" :disabled="vuetableFilterButton">Limpar</button>
                            </div>
                        </div>
                    </b-col>
                </b-row>
            </b-container>
        </div>
    </div>
</template>

<script>
import Multiselect from 'vue-multiselect'
export default {
  components: {
      Multiselect
  },
  data () {
    return {
      helpForm: new Form({params: []}),
      cd: '',
      cd_erp: '',
      descr: '',
      optionsLivStatus: [],
      status: [],
      optionsParamCusto: [],
      custo: [],
      optionsParamRateio: [],
      rateio: [],
      optionsLivMandatorio: [],
      mandatorio: [],
      data_filter: []
    }
  },
  mounted() {
      this.getLivGeral();
    },
  methods: {
      doFilter () {
          this.$store.commit('setVuetableFilterButton', true);
          this.data_filter = {cd: this.cd,
                              cd_erp: this.cd_erp,
                              descr: this.descr,
                              status: this.status,
                              custo: this.custo,
                              rateio: this.rateio,
                              mandatorio: this.mandatorio}
          this.$events.fire('filter-set', this.data_filter);
      },
      resetFilter () {
        this.cd = '';  // clear the text in text input
        this.cd_erp = '';
        this.descr = '';
        this.status = '';
        this.mandatorio = '';
        this.custo = '';
        this.rateio = '';
        this.$events.fire('filter-reset');
      },
      getLivGeral()
      {
          this.helpForm.get('/api/custo/jsonlistgeral').then(response =>
          {
              new ReturnApi(response, this, true, false, false);
              response.status.forEach((obj)=>
              {
                  this.optionsLivStatus.push({ label: obj.descr, value: obj.valor })
              })
              response.mandatorio.forEach((obj)=>
              {
                  this.optionsLivMandatorio.push({ label: obj.descr, value: obj.valor })
              })
              response.param_rateio.forEach((obj)=>
              {
                  this.optionsParamRateio.push({ label: obj.descr, value: obj.partiprat_id })
              })
              response.param_custo.forEach((obj)=>
              {
                  this.optionsParamCusto.push({ label: obj.descr, value: obj.partipcus_id })
              })
          })
          .catch(errors =>
          {
              new ReturnApi(errors, this)
          });
      },
  },
  computed: {
    vuetableFilterButton: {
      get () {
        return this.$store.state.vuetable.filterButton;
      },
     },
    }
}
</script>
